import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import classNames from 'lib/util/classNames'
import styles from './Divider.module.scss'
import { MASK } from './constants'

/**
 * The `Divider`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Divider (props) {
  const { className, mask } = props
  const maskStr = useMemo(() => MASK[mask] || mask, [mask])
  const classNameOutput = useMemo(
    () => classNames([className, styles.divider, styles[`mask-${maskStr}`]]),
    [className, maskStr]
  )

  return (
    <div className={classNameOutput} aria-hidden="true">
      <div className={styles.block} />
    </div>
  )
}

/** @type {object} */
Divider.propTypes = {
  className: PropTypes.string,
  mask: PropTypes.string,
  type: PropTypes.string
}

/** @type {object} */
Divider.defaultProps = {
  className: '',
  mask: 'short'
}

// Memoize
export default memo(Divider)
